module.exports = __webpack_public_path__ + "img/photo-studio-carousel.334f8264.gif";